module.exports = __webpack_public_path__ + "img/ke.8c42a857.svg";